import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";

const TipTapEditor = ({ value, onChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: "Write your blog description...",
      }),
    ],
    content: value || "",
   onUpdate: ({ editor }) => {
  onChange(editor.getHTML());
},
  });

  useEffect(() => {
    if (!editor) return;

    if (editor.getHTML() !== (value || "")) {
      editor.commands.setContent(value || "");
    }
  }, [value, editor]);

  return (
    <div className="tiptap-wrapper">
      <EditorContent editor={editor} className="tiptap-editor" />
    </div>
  );
};

export default TipTapEditor;